module.exports = __webpack_public_path__ + "img/shipping.63d188ce.svg";